//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
import { ref, computed, onMounted } from '@vue/composition-api'
import { useRouter } from '@core/utils'

export default {
  setup() {
    const { route, router } = useRouter()

    const saveCard = ref(null)
    const patmentIntent = ref(null)
    const computedMatchCode = computed(() => JSON.parse(localStorage.getItem('matchCode')))

    const onFinishedPayment = () => {
      router.push({ path: `/game/${computedMatchCode.value}` })
    }

    onMounted(() => {
      const { params, query } = route.value
      saveCard.value = params.saveCard
      patmentIntent.value = query.payment_intent
    })

    return {
      patmentIntent,

      computedMatchCode,

      onFinishedPayment,
    }
  },
}
